export const RESET_STATE = 'global/RESET_STATE';

export const resetStateAction = () => dispatch => dispatch({ type: RESET_STATE });
